import { fetchConfig, fetchConfigs, putConfig } from '@/api/config'
import { store } from '@/store'
import { Config } from '@/models/config'
import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({ name: 'Config', dynamic: true, store })
class ConfigModule extends VuexModule {
  configs: Record<string, any> = {}

  @Mutation
  updateConfig(config: Config) {
    this.configs = {
      ...this.configs,
      [config.key]: config.value
    }
  }
}

export const ConfigStore = getModule(ConfigModule)

export async function preloadConfig(): Promise<void> {
  try {
    const configs = await fetchConfigs()
    configs
      .map(({ key, value }) => ({ key, value: JSON.parse(value) }))
      .forEach(config => ConfigStore.updateConfig(config))
  } catch (e) {
    // todo
  }
}

export async function getConfig<RType = any>(
  key: string
): Promise<RType | null> {
  if (ConfigStore.configs[key]) {
    return ConfigStore.configs[key] as RType
  }

  try {
    const config = await fetchConfig(key)
    const value = JSON.parse(config.value)
    ConfigStore.updateConfig({ key, value })
    return value
  } catch (e) {
    return null
  }
}

export async function updateConfig(key: string, value: any) {
  try {
    const config = {
      key,
      value: JSON.stringify(value)
    }
    await putConfig(config)
    ConfigStore.updateConfig({ key, value })
  } catch (e) {
    // TODO
  }
}
